import styled from 'styled-components';

export const Container = styled.div`
  align-content: center;
  display: grid;
  gap: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  height: 100%;
  justify-content: center;
  text-align: center;
  width: ${({ theme }) => theme.yoga.sizes.containerWidth}px;
`;

export const Icon = styled.div`
  text-align: center;
`;

export const Content = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.yoga.spacing.small}px;
  text-align: center;
`;

export const Text = styled.h2`
  color: ${({ theme }) => theme.yoga.colors.textPrimary};
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  font-size: ${({ theme }) => theme.yoga.fontSizes.xlarge}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.xlarge}px;
  text-align: center;
`;

export const Footer = styled.footer`
  display: grid;
  justify-content: center;
  margin-top: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;
